module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a11_chart"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_c('p', {
    staticClass: "chart"
  }, [_vm._v("List of Charts")]), _vm._v(" "), _c('p', {
    staticClass: "chart1"
  }, [_c('i', [_vm._v("(at end of volume)")])]), _vm._v(" "), _c('p', {
    staticClass: "chart1"
  }, [_vm._v("(Times, as in the text, are G.M.T.)")])]), _c('p', {
    staticClass: "chart2"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/29_themaps#mapf1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. North Sea, including opening movements of the Battle of Jutland. 2-15. The Battle of Jutland:")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The situation at 2.45 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.     „     „     „     3.15 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.     „     „     „     4.10 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.     „     „     „     4.50 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.     „     „     „     5.30 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.     „     „     „     6.00 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.     „     „     „     6.30 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.     „     „     „     7.00 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.   „     „     „     7.25 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.   „     „     „     8.05 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.   „     „     „     9.00 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.   „     „     „     10.00 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.   Movements from 10.00 p.m. to 12.15 a.m")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.       „     „    12.15 a.m. to 6.00 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chart2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_themaps#mapf16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.   North Sea Operations on 19 August 1916")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25bed854","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/11_chart.vue
// module id = 87
// module chunks = 0